module.exports = __webpack_public_path__ + "static/media/DK4055_09.bc4045b3.jpg";